"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _scroll = _interopRequireDefault(require("scroll")),
    _scrollDoc = _interopRequireDefault(require("scroll-doc")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _ProgressBar = _interopRequireDefault(require("./ProgressBar")),
    _ActionButton = _interopRequireDefault(require("../../ActionButton")),
    _wizard = require("../styles/wizard");

function _createSuper(a) {
  return function () {
    var b,
        c = (0, _getPrototypeOf2["default"])(a);

    if (_isNativeReflectConstruct()) {
      var d = (0, _getPrototypeOf2["default"])(this).constructor;
      b = Reflect.construct(c, arguments, d);
    } else b = c.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, b);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var scrollElement = (0, _scrollDoc["default"])();

function scrollToTop() {
  _scroll["default"].top(scrollElement, 0);
}

var Wizard = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), _initialiseProps.call((0, _assertThisInitialized2["default"])(d)), scrollToTop(), d.state = {
      totalStages: a.children.length || 1,
      stage: a.initialStage,
      displayStage: 0
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var a = this;
      setTimeout(function () {
        a.setState(function (a) {
          var b = a.stage;
          return {
            displayStage: b
          };
        });
      }, 0);
    }
  }, {
    key: "handleBack",
    value: function handleBack() {
      var a = this.props.onBack,
          b = this.state.stage;
      return a ? void (a({
        stage: b
      }), scrollToTop()) : void scrollToTop();
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.state,
          b = a.stage,
          c = a.displayStage,
          d = a.totalStages,
          e = this.props,
          f = e.hideBack,
          g = e.className,
          h = this.addNavigationToChildren(this.props);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_wizard.DEFAULT, "wizard", g)
      }, _react["default"].createElement(_ProgressBar["default"], {
        currentStage: c,
        maxStage: d
      }), _react["default"].createElement(_ActionButton["default"], {
        labelText: "BACK",
        icon: "return",
        onClick: this.goToPreviousStage,
        visible: !f && 1 !== b,
        className: _wizard.BACK_BTN,
        iconSize: 15
      }), _react["default"].createElement("div", {
        className: (0, _classnames["default"])(_wizard.CONTENT, "wizard__content")
      }, h[b - 1] || h));
    }
  }]), b;
}(_react.Component);

exports["default"] = Wizard, Wizard.defaultProps = {
  initialStage: 1
};

var _initialiseProps = function _initialiseProps() {
  var a = this;
  this.addNavigationToChildren = (0, _lodash["default"])(function (b) {
    var c = b.children,
        d = {
      goToNextWizardStage: a.goToNextStage
    };
    if (!Array.isArray(c)) return _react["default"].cloneElement(c, d);
    var e = c.filter(function (a) {
      return null !== a;
    });
    return e.map(function (a) {
      return _react["default"].cloneElement(a, d);
    });
  }), this.goToNextStage = function () {
    var b = a.state,
        c = b.stage,
        d = b.totalStages;
    c === d || a.setState(function (a) {
      var b = a.stage;
      return {
        stage: b + 1,
        displayStage: b + 1
      };
    }, scrollToTop);
  }, this.goToPreviousStage = function () {
    a.setState(function (a) {
      var b = a.stage;
      return {
        stage: b - 1,
        displayStage: b - 1
      };
    }, a.handleBack);
  };
};